export default () => ({
    root: {
        margin: "15px 0",
    },
    "@global": {
        ".react-share__ShareButton": {
            marginRight: ".5rem",
        }
    }
});